'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dProxy$002dName$0024 from "./presto.types$-Proxy-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_Proxies$$anon$4(outer) {
  this.brD = null;
  this.brB = null;
  this.brC = false;
  this.brz = null;
  this.brA = false;
  this.brE = false;
  this.brF = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.brD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Proxies$$anon$4 as $c_Lpresto_Proxies$$anon$4 };
$p = $c_Lpresto_Proxies$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Proxies$$anon$4;
/** @constructor */
function $h_Lpresto_Proxies$$anon$4() {
}
export { $h_Lpresto_Proxies$$anon$4 as $h_Lpresto_Proxies$$anon$4 };
$h_Lpresto_Proxies$$anon$4.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.brD;
});
$p.t = (function() {
  if ((!this.brC)) {
    this.brB = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.brC = true;
  }
  return this.brB;
});
$p.ag = (function() {
  if ((!this.brA)) {
    this.brz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dProxy$002dName$0024.$m_Lpresto_types$ProxyName$().csX(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.brA = true;
  }
  return this.brz;
});
$p.v = (function() {
  if ((!this.brF)) {
    this.brE = false;
    this.brF = true;
  }
  return this.brE;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Proxies$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Proxies$$anon$4, "presto.Proxies$$anon$4", ({
  Pm: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Proxies$$anon$4 as $d_Lpresto_Proxies$$anon$4 };
//# sourceMappingURL=presto.-Proxies$$anon$4.js.map
